import { render, staticRenderFns } from "./PlatformDock.vue?vue&type=template&id=73baa156&scoped=true"
import script from "./PlatformDock.vue?vue&type=script&lang=js"
export * from "./PlatformDock.vue?vue&type=script&lang=js"
import style0 from "./PlatformDock.vue?vue&type=style&index=0&id=73baa156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73baa156",
  null
  
)

export default component.exports